import { IMoveTracker } from '@nkr/models/index';

export interface IMarker {
    lat: number,
    lng: number,
    text: string,
    color: string,
    data: IMoveTracker,
    isDonorCenter: boolean,
    isWaypoint: boolean,
    isLast: boolean,
    pickupDateTime: string,
    arrivalDateTime: string,
    batteryPercentage: number
}